import * as React from "react";
import { IconBase, IIconBase } from "./IconBase";

export const PlantLayoutsIcon = ({ ...props }: IIconBase) => (
  <IconBase {...props}>
    <title>Plant Layouts</title>
    <path d="M26 24V6H6v36h36V24zm-12 5l1-9h-5l9-12-1 10h5zm17 10h-4v-4h4zm0-8h-4v-4h4zm8 8h-4v-4h4zm0-8h-4v-4h4z" />
  </IconBase>
);
